import {
    Box,
    Button,
    FormControlLabel,
    InputBase,
    Radio,
    RadioGroup,
    Typography,
} from "@mui/material"
import useProfile from "common/hooks/swr/useProfile"
import useImpersonationEmail from "common/hooks/useImpersonationEmail"
import useSearchType from "common/hooks/useSearchType"
import { useSegmentTrack } from "common/hooks/useSegmentTrack"
import * as searchStyles from "features/UnitTracker/components/ImpersonateInput.styles"
import { useRouter } from "next/router"
import { useState } from "react"
import { Dusk } from "themes/colours"
import { SearchType } from "types/search"

const ImpersonateInput = () => {
    const router = useRouter()
    const [, setSearchType] = useSearchType()
    const [emailValue, setEmailValue] = useState<string>()
    const [searchTypeInput, setSearchTypeInput] = useState<string>(
        SearchType.MyUnits
    )

    const [, setImpersonationEmail] = useImpersonationEmail()
    const { trackEvents } = useSegmentTrack()
    const { data: profile } = useProfile()
    return (
        <>
            {profile?.roles.isOnboardingAdmin ? (
                <>
                    <RadioGroup
                        aria-label="search type"
                        name="searchType"
                        value={searchTypeInput}
                        onChange={(event) =>
                            setSearchTypeInput(event.target.value)
                        }
                        row
                    >
                        <>
                            <FormControlLabel
                                value={SearchType.MyUnits}
                                control={<Radio size="small" />}
                                label={
                                    <Typography
                                        variant="bodySmall"
                                        color={Dusk[100]}
                                    >
                                        My Units
                                    </Typography>
                                }
                            />
                        </>

                        <>
                            <FormControlLabel
                                value={SearchType.MyTeam}
                                control={<Radio size="small" />}
                                label={
                                    <Typography
                                        variant="bodySmall"
                                        color={Dusk[100]}
                                    >
                                        My Team
                                    </Typography>
                                }
                            />
                        </>
                    </RadioGroup>
                    <Box css={searchStyles.searchContainer}>
                        <form
                            onSubmit={async (e) => {
                                e.preventDefault()
                                setImpersonationEmail(emailValue)
                                setSearchType(searchTypeInput)

                                router.push(
                                    {
                                        pathname: "/",
                                    },
                                    undefined,
                                    { shallow: true }
                                )

                                trackEvents("impersonate_by_email", {
                                    search_type: searchTypeInput,
                                })
                            }}
                            css={searchStyles.searchForm}
                        >
                            <InputBase
                                css={searchStyles.searchInput}
                                value={emailValue ?? ""}
                                onChange={(e) => setEmailValue(e.target.value)}
                                placeholder="Impersonate email"
                            />
                            <Button
                                css={searchStyles.searchSubmit}
                                type="submit"
                            >
                                Go
                            </Button>
                        </form>
                    </Box>
                </>
            ) : null}
        </>
    )
}

export default ImpersonateInput
